// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// 引入 ElementUI
import ElementUI from 'element-ui'
//修改弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false

import './assets/ele-theme/index.css'
import './assets/fonts/iconfont.css'

// Vuex
import store from './store'

import App from './App'

// js 类库
import CommonJs from '../static/js/common.js'
import RsaJs from '../static/js/rsa.js'

//写入配置
Object.entries(window.config).forEach(function (each) {
    localStorage.setItem(each[0], each[1])
})

import axios from 'axios'

Vue.config.productionTip = false

axios.defaults.withCredentials = true

const instance = axios.create({
    //全局域名
    baseURL: localStorage.getItem('ServerUrl')
})

//请求拦截器
instance.interceptors.request.use(function (config) {
    let jwt = localStorage.getItem('jwt')
    //在发送之前，token等处理
    if (jwt) {
        config.headers['Authorization'] = jwt
    }
    return config
}, function (err) {
    //对请求错误处理
    return Promise.reject(err)
})

//响应拦截器
instance.interceptors.response.use(function (res) {
    let d = res.data
    //正确处理
    if (d.hasOwnProperty('status') && d.status !== 0) {
        if (d.status === -2) {
            let getParams = function () {
                let url = window.location.href
                if (url.indexOf('?') === -1) {
                    return {}
                }
                let str = url.split('?')[1]
                str = str.split('#')[0]
                str = str.split('&')
                let params = {}
                let item = []
                for (let i = 0; i < str.length; i++) {
                    item = str[i].split('=')
                    //url解码
                    params[item[0]] = decodeURIComponent(item[1])
                }
                return params
            }
            //业务错误，跳转至登录页
            let params = getParams()
            if (params.hasOwnProperty('jwt')) {
                //强制跳转至首页
                console.log('jmp 1')
                window.location.href = '/'
            } else {
                console.log('jmp 2')
                //路由方式跳转至首页
                router.push('/')
            }
        } else {
            //统一错误提醒
            ElementUI.Message.error(d.message)
        }
        return Promise.reject(new Error(d.message))
    } else {
        if (d.message.length > 0) {
            ElementUI.Message.success(d.message)
        }
        return d
    }
}, function (err) {
    console.log('err:', err)
    return Promise.reject(err)
})

Vue.prototype.$ajax = instance

// vue-router
import router from './router'

Vue.use(ElementUI)
Vue.use(CommonJs)
Vue.use(RsaJs)

// 用闭包实现局部对象storage(注意Storage的方法都重写一遍，不然调用其对象原型方法会报错。)
let localStorageMock = (function (win) {
    let storage = win.localStorage
    return {
        setItem: function (key, value) {
            let setItemEvent = new Event('setItemEvent')
            let oldValue = storage[key]
            setItemEvent.key = key
            // 新旧值深度判断，派发监听事件
            if (oldValue !== value) {
                setItemEvent.newValue = value
                setItemEvent.oldValue = oldValue
                win.dispatchEvent(setItemEvent)
                storage[key] = value
                return true
            }
            return false
        },
        getItem: function (key) {
            return storage[key]
        },
        removeItem: function (key) {
            storage[key] = null
            return true
        },
        clear: function () {
            storage.clear()
            return true
        },
        key: function (index) {
            return storage.key(index)
        }
    }
}(window))
Object.defineProperty(window, 'localStorage', {value: localStorageMock, writable: true})

Vue.filter('mobileSafety', function (value) {
    if (value) {
        return value.substring(0, 3) + '****' + value.substring(7)
    } else {
        return '-'
    }
})

Vue.filter('emailSafety', function (value) {
    if (value) {
        let pre = value.substring(0, value.indexOf('@'))
        if (pre.length > 3) {
            pre = pre.substring(0, 3) + '***'
        } else {
            pre += '***'
        }
        return pre + value.substring(value.indexOf('@'))
    } else {
        return '-'
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js